import { useDepositToPortfolioMutation } from 'hooks/mutations/Rewards/useDepositToPortfolioMutation'
import { useRewardsTracking } from 'pages/Rewards/hooks/useRewardsTracking'
import { BaseErrorResponse } from 'types/beneficiaries'
import { PortfolioTransportRequest, PortfolioTransportResponse } from 'types/rewards'

export const useDepositPortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: PortfolioTransportResponse) => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()
  const { mutate: depositToPortfolio, isPending: isDepositingToPortfolioPending } =
    useDepositToPortfolioMutation()

  const handleDepositToPortfolio = (data: PortfolioTransportRequest) => {
    const {
      counterparty: { walletId, amount },
    } = data

    return depositToPortfolio(data, {
      onSuccess: data => {
        trackSuccess('allocate', {
          walletId,
          amount,
        })
        onSuccess?.(data)
      },
      onError: (error: BaseErrorResponse) => {
        trackError('allocate', error, {
          walletId,
          amount,
        })
        onError?.(error)
      },
    })
  }

  return {
    depositToPortfolio: handleDepositToPortfolio,
    isDepositingToPortfolioPending,
  }
}
